module.exports = __webpack_public_path__ + "img/photo2_5.60f16b63.jpg";